import { FilterChips } from 'shared/mui/Filter/FilterChips/FilterChips';

import { useOrdersReportFilterFields } from './hooks/useOrdersReportFilterFields';

export const OrdersReportListFilterChips: React.FC = () => {
  const fields = useOrdersReportFilterFields();

  return <FilterChips fields={fields} />;
};
